module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Medium.cbd5d59.woff2";